import * as angular from 'angular';
import { OidcService } from './OidcService';
import { AuthorizeController } from './AuthorizeController';
import { AuthorizeExternalController } from './AuthorizeExternalController';
import { AuthorizeServiceFactory } from './AuthorizeServiceFactory';
export const authorizeStateName = 'anon.authorize';
export const authorizeExternalStateName = `${authorizeStateName}-external`;
export const authorizeModule = angular
    .module('authorize', [])
    .service('OidcService', OidcService)
    .service('AuthorizeServiceFactory', AuthorizeServiceFactory)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(authorizeStateName, {
            url: '/authorize',
            controller: AuthorizeController,
        })
            .state(authorizeExternalStateName, {
            url: '/authorize-external',
            controller: AuthorizeExternalController,
        });
    }]).name;
